<div class="w-100 position-relative landing-container">
  <div class="position-sticky top-0 left-0 header">
    <app-header></app-header>
  </div>
  <div fadeInScroll class="position-relative z-3">
    <app-hero-section></app-hero-section>
  </div>
  <div fadeInScroll class="position-relative z-5">
    <app-description-section></app-description-section>
  </div>
  <div fadeInScroll><app-services-section></app-services-section></div>
  <div fadeInScroll><app-key-figures></app-key-figures></div>
  <div fadeInScroll><app-tools-section></app-tools-section></div>
  <div fadeInScroll><app-contact-section></app-contact-section></div>
  <div fadeInScroll><app-footer (showDPO)="onShowDPO()"></app-footer></div>
  <app-privacy-policy
    [showDPO]="showDPO"
    (closeDPO)="onCloseDPO()"
  ></app-privacy-policy>
</div>
